import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getCardIcon,
  getCardIconType,
  getCardTitle,
  getChangeType,
} from "../MemberReportMocks.js";
import CalendarLoader from "../../../common-components/CalendarLoader.jsx";

const MemberReportStat = ({ setModValues, filters }) => {
  const {
    memberCheckinMetrics,
    memberCheckinMetricsLoading,
    memberCheckinMetricsError,
  } = useSelector((state) => state.prospects);

  const [statsData, setStatsData] = useState(null);

  useEffect(() => {
    if (
      !memberCheckinMetricsLoading &&
      !memberCheckinMetricsError &&
      memberCheckinMetrics?.status
    ) {
      setStatsData(memberCheckinMetrics?.data);
    } else {
      setStatsData(null);
    }
  }, [
    memberCheckinMetricsLoading,
    memberCheckinMetricsError,
    memberCheckinMetrics,
  ]);

  const handleCardClick = (key, value) => {
    if (value > 0) {
      setModValues((prevs) => ({
        ...prevs,
        isModOpen: true,
        modName: "member_detail",
        filterType: key,
        filters: filters,
      }));
    }
  };

  return (
    <div className="mr-kpi-grid mt30">
      {memberCheckinMetricsLoading ? (
        <CalendarLoader daysCount={6} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, data]) => {
          const value = data?.value || 0;
          const isClickable = value > 0;

          return (
            <div
              className={`mr-kpi-card ${
                isClickable ? "mr-kpi-card--clickable" : ""
              }`}
              key={key}
              onClick={() => handleCardClick(key, value)}
              style={{ cursor: isClickable ? "pointer" : "default" }}
              title={isClickable ? `View ${getCardTitle(key)}` : ""}
            >
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">{getCardTitle(key)}</p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">{value}</div>
                    {data.change && (
                      <div
                        className={`mr-kpi-trend mr-kpi-trend--${getChangeType(
                          data.change_type
                        )}`}
                      >
                        {data.change}
                      </div>
                    )}
                  </div>

                  {data.assigned_percentage && (
                    <div className="mr-kpi-subtitle">
                      {data.assigned_percentage}
                    </div>
                  )}
                </div>
                <span
                  className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(key)}`}
                >
                  {getCardIcon(key)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default MemberReportStat;
